import { GET_ALL_DEVICE_ALARM_MAPPINGS } from "./actionTypes";

const initialState = {};

const deviceAlarmMappings = (state = initialState, action) => {
	const { payload, type } = action;

	switch (type) {
		case GET_ALL_DEVICE_ALARM_MAPPINGS: {
			return (payload || []).reduce((acc, mapping) => {
				if (!mapping?.alarmType) return acc;
				acc[mapping.alarmType] = mapping;
				return acc;
			}, {});
		}
		default:
			return state;
	}
};

export default deviceAlarmMappings;
